import PropTypes from "prop-types";

export const CarouselProps = {
  options: PropTypes.object,
  renderItems: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  children: PropTypes.node,
  speed: PropTypes.number,
  pauseOnHover: PropTypes.bool,
  pauseOnDocumentScroll: PropTypes.bool,
  loop: PropTypes.bool,
  autoScroll: PropTypes.bool,
  onInit: PropTypes.func,
};
